import { Outlet } from 'react-router-dom';
import { Box, Container } from '@mui/material';

import { Header } from './Header';

const Layout = () => {
    return (
        <Box minHeight="100svh" position="relative" display="flex" flexDirection="column" sx={{ backgroundColor: 'background.gray' }}>
            <Header />
            <Container maxWidth="md" sx={{ display: 'flex', flex: '1', padding: '0 !important' }}>
                <Outlet />
            </Container>
        </Box>
    );
};

export default Layout;
